import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
export const MenuItem = ({ menuitem, check, openMenu }) => {
  const sampleLocation = useLocation();

  const [innerShow, setInnerShow] = useState(false);
  const [isActived, setIsActived] = useState(false);

  useEffect(() => {
    if (sampleLocation.pathname === menuitem.url) {
      setIsActived(true);
    } else {
      setIsActived(false);
    }
  }, [sampleLocation.pathname]);

  useEffect(() => {
    if (openMenu) {
      setTimeout(() => {
        setInnerShow(openMenu);
      }, 300);
    } else {
      setInnerShow(openMenu);
    }
  }, [openMenu]);

  return (
    <NavLink
      hidden={!check}
      className={`menu-item ${isActived && "menu-item-active"} ${
        !openMenu && "menu-item-small"
      }`}
      to={menuitem.url}
    >
      <img src={menuitem.icon} className="menu-item__icon" />
      {innerShow && <>{menuitem.text}</>}
    </NavLink>
  );
};
